import PageHeadline from "../../PageHeadline/PageHeadline";
import PageContentContainer from "../../Container/PageContentContainer";
import LegalbirdLoader from "../../ContentLoader/LegalbirdLoader";
import AttachmentMerges from "../../AttachmentMerges/AttachmentMerges.tsx";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../services/ReactQuery/reactQueryService.ts";
import { HydraCollectionResult } from "../../../types/HydraCollectionResult.ts";
import AttachmentMerge from "../../../types/AttachmentMerge.ts";

export default function AttachmentMergesPage() {
  const attachmentMergeUri = "attachment_merges";
  const attachmentMergeFilter = {
    status: "open",
  };

  const { data: attachmentMerges, isLoading } = useQuery<HydraCollectionResult<AttachmentMerge>>({
    queryKey: queryKeys.collection(attachmentMergeUri, attachmentMergeFilter),
    queryFn: () => fetchCollection(attachmentMergeUri, attachmentMergeFilter),
  });

  if (isLoading || !attachmentMerges) {
    return <LegalbirdLoader centered={true} />;
  }

  return (
    <PageContentContainer>
      <PageHeadline main="Anlagen verarbeiten" />
      <AttachmentMerges
        attachmentMerges={attachmentMerges["hydra:member"].filter((attachmentMerge) => attachmentMerge.type === "bea")}
        headline={"beA"}
      />
      <AttachmentMerges
        attachmentMerges={attachmentMerges["hydra:member"].filter(
          (attachmentMerge) => attachmentMerge.type === "email",
        )}
        headline={"Email"}
      />
    </PageContentContainer>
  );
}
